import { Plugin, defineAsyncComponent } from "vue";

const componentImports = {
  SpireButton: () => import("@/courses/components/structure/SpireButton.vue"),
};

declare module "vue" {
  interface GlobalComponents {
    SpireButton: typeof componentImports.SpireButton;
  }
}
const CoreComponentPlugin: Plugin = {
  install(app) {
    Object.entries(componentImports).forEach(
      ([componentName, componentImport]) => {
        app.component(componentName, defineAsyncComponent(componentImport));
      },
    );
  },
};

export default CoreComponentPlugin;
